import { CANONICAL_STAGE_VALUES, type CanonicalStage } from './signal-type-registry.js';

// PROJECT_STAGE_VALUES / ProjectStage are the canonical forward-only regulatory
// funnel (re-exported from the registry). The legacy 6-value stage vocabulary is
// gone from consumer code.
export const PROJECT_STAGE_VALUES = CANONICAL_STAGE_VALUES;
export type ProjectStage = CanonicalStage;

export interface ProjectStageDefinition {
  value: ProjectStage;
  label: string;
  /** One-sentence, plain-language meaning of this stage (tooltips, API/MCP). */
  description: string;
}

export const PROJECT_STAGE_DEFINITIONS: readonly ProjectStageDefinition[] = [
  {
    value: 'pre_filing',
    label: 'Pre-filing',
    description:
      'Early activity detected, such as a site acquisition, project announcement, or pre-application meeting, but no formal land-use application has been submitted yet.',
  },
  {
    value: 'filed',
    label: 'Filed',
    description:
      'A formal land-use or entitlement application has been filed: Article 80 large or small project review, special permit, variance, rezoning, or site plan review.',
  },
  {
    value: 'under_review',
    label: 'Under review',
    description:
      'The application is in active review: public hearings have been scheduled, staff reports issued, or a public comment period is open.',
  },
  {
    value: 'approved',
    label: 'Approved',
    description:
      'The discretionary land-use approval has been granted (zoning approval, Article 80 approval, special permit, etc.). A building permit has not yet been issued.',
  },
  {
    value: 'permitted',
    label: 'Permitted',
    description:
      'A building permit, demolition permit, major site-work permit, or construction financing has closed. Construction is authorized but may not yet be underway.',
  },
  {
    value: 'under_construction',
    label: 'Under construction',
    description:
      'Construction is physically underway, confirmed through site activity reports, inspection records, or an under_construction signal from a verified source.',
  },
  {
    value: 'completed',
    label: 'Complete',
    description: 'Construction has finished or a certificate of occupancy has been recorded.',
  },
];
